<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="structure-img"><span><img alt="RealLifeOrg_FINAL-4.png" class="frame2" src="OEBPS/image/RealLifeOrg_FINAL-4_fmt.png"/></span><span class="normal-caps"> </span></p>
<div class="calibre2" id="calibre_pb_3"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// RealLifeOrg_split_003.vue?960bcb00